export default {
  zh: {
    accountOverview: '账户总览',
    me: '我的账号',
    serviceTime: '套餐余额',
    CNY: '￥',
    D: '天',
    H: '小时',
    m: '分钟',
    devices: '台',
    serviceInstructions: '订购续费后，服务时长会直接累加',
    inviteFriends: '邀请好友',
    friends: '位',
    rewards: '奖励天数',
    rewardsDescribe: '好友充值成功以后，您和好友都将获得免费时长奖励。',
    days: '天',
    deviceNum: '设备数量',
    myInvitationCode: '我的邀请码',
    invitationCode: '邀请码：',
    expireIn: '到期',
    rewardRules: '奖励规则'
  },
  en: {
    accountOverview: 'Account',
    me: 'My Account',
    serviceTime: 'Balance',
    USD: '$',
    D: 'Day | Days',
    H: 'Hour | Hours',
    m: 'Minute | Minutes',
    devices: 'Device | Devices',
    serviceInstructions: 'VIP service time will be extended directly after subscription renewal',
    inviteFriends: 'Invite friends',
    friends: 'Friend | Friends',
    rewards: 'Rewards',
    rewardsDescribe: 'Both of you will get free VIP service time once your friend successfully purchase a plan. ',
    days: 'Day | Days',
    deviceNum: 'Device num',
    myInvitationCode: 'My Invitation Code',
    invitationCode: 'Invitation Code: ',
    expireIn: 'Expires on',
    rewardRules: 'Reward Rules'
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/accountInfo/lang.js